import { IconJourneyItem } from '@components/icons/journey-icon';
import { RelativeSpinner } from '@components/loading-spinner';
import { Sidebar, hideSidebar } from '@components/sidebar';
import { useScopedTranslate } from '@locale/translate';

import { createJourneyActionFieldPath } from 'api/documents/requests';
import { useJourneyAction, useUpdateJourneyAction } from 'api/journey-actions/hooks';
import { ActionHeader, SidebarProps } from 'ui/journey-builder/node-types/common';

import { AddToJourneyFormContent } from './helpers';

type ActionType = 'add_to_journey';

export const SidebarContent = (props: SidebarProps) => {
  const { t } = useScopedTranslate(sidebarLocale);
  const { journeyActionId } = props;
  const { data, isLoading } = useJourneyAction<ActionType>(journeyActionId);
  const editMutation = useUpdateJourneyAction(journeyActionId);

  if (isLoading || !data) {
    return <RelativeSpinner />;
  }
  const filePath = createJourneyActionFieldPath(data.journey, journeyActionId);

  return (
    <Sidebar>
      <ActionHeader title={t('title')} icon={IconJourneyItem} iconColor="teal100" {...props} />
      <Sidebar.Content>
        <AddToJourneyFormContent
          action={data}
          originalJourney={data.journey}
          filePath={filePath}
          onCancel={hideSidebar}
          onSubmit={(data) =>
            editMutation.mutateAsync({
              isAutomatic: true,
              action: 'add_to_journey',
              values: data.values,
              description: data.description,
            })
          }
        />
      </Sidebar.Content>
    </Sidebar>
  );
};

const sidebarLocale = {
  en: {
    title: 'Add traveller to journey',
  },
};
